import React, { Component } from 'react';
import Modal from '../modal/index';

const withModal = visibilityProp => WrappedComponent => class extends Component {
    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
        this.isVisible = this.isVisible.bind(this);
        this.state = {
            isVisible: false
        };
    }

    isVisible() {
        const { props } = this;
        return (
            props[visibilityProp] !== null &&
            props[visibilityProp] !== undefined &&
            props[visibilityProp] === true
        );
    }

    close(closeCallback) {
        this.setState({
            isVisible: false
        });
        closeCallback();
    }

    render() {
        const modalProps = {
            close: this.close
        };

        const modalContent = this.isVisible() ? (
            <WrappedComponent
                {...this.props}
                {...this.state}
                modal={modalProps}
            />
        ) : '';
        return (
            <Modal show={this.isVisible()}>
                <div className="is-a-modal">
                    {modalContent}
                </div>
            </Modal>
        );
    }
};

export default withModal;



// WEBPACK FOOTER //
// ./app/components/with-modal/index.js